'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _draftJs = require('draft-js');

var _emojisList = require('./emojis-list');

var _emojisList2 = _interopRequireDefault(_emojisList);

var _util = require('./util');

var _DraftOffsetKey = require('draft-js/lib/DraftOffsetKey');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var emojiMap = {};

_emojisList2["default"].forEach(function (emoji) {
  var shortCut = emoji.shortCut;

  emojiMap[shortCut] = emoji;
});

var EmojiRaw = function (_React$Component) {
  _inherits(EmojiRaw, _React$Component);

  function EmojiRaw() {
    _classCallCheck(this, EmojiRaw);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  EmojiRaw.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props;
    var decoratedText = _props.decoratedText;
    var callbacks = _props.callbacks;
    var offsetKey = _props.offsetKey;
    var getEditorState = callbacks.getEditorState;
    var setEditorState = callbacks.setEditorState;

    var editorState = getEditorState();
    var contentState = editorState.getCurrentContent();
    var blockMap = contentState.getBlockMap();

    var _decode = (0, _DraftOffsetKey.decode)(offsetKey);

    var blockKey = _decode.blockKey;
    var decoratorKey = _decode.decoratorKey;
    var leafKey = _decode.leafKey;

    var leaf = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]);
    if (!leaf) {
      return false;
    }
    var startKey = leaf.get('start');
    var endKey = leaf.get('end');
    console.log('EmojiRaw', startKey, endKey);
    var selection = _draftJs.SelectionState.createEmpty();
    var updatedSelection = selection.merge({
      anchorKey: blockKey,
      anchorOffset: startKey,
      focusKey: blockKey,
      focusOffset: endKey
    });
    if (emojiMap.hasOwnProperty(decoratedText)) {
      var newEditorState = (0, _util.replaceEntity)(editorState, updatedSelection, ' ', (0, _util.createEntity)('emoji', { emoji: emojiMap[decoratedText], "export": _util.exportEntity }));

      setEditorState(_draftJs.EditorState.moveFocusToEnd(newEditorState));
    }
    // if (emojiMap.hasOwnProperty(decoratedText)) {
    //   Entity.replaceData(entityKey, emojiMap[decoratedText]);
    // }
  };

  EmojiRaw.prototype.render = function render() {
    return _react2["default"].createElement(
      'span',
      { style: { backgroundColor: 'red' } },
      this.props.children
    );
  };

  return EmojiRaw;
}(_react2["default"].Component);

exports["default"] = EmojiRaw;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-editor-plugin-emoji@0.2.9@rc-editor-plugin-emoji/lib/EmojiRaw.js
// module id = 219
// module chunks = 0 1 2